"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextColor = exports.focusStyles = exports.focusStyleBoxShadow = exports.Link = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
var _excluded = ["component", "isUsingKeyboard", "useBrowserDefaultFocusStyle", "isHover", "isFocus", "isActive", "standalone", "semanticColor", "hasInheritColor"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var getTextColor = exports.getTextColor = function getTextColor(_ref) {
  var hasInheritColor = _ref.hasInheritColor,
    semanticColor = _ref.semanticColor;
  return hasInheritColor ? 'inherit' : (0, _index.cssColorValue)(semanticColor);
};
var focusStyleBoxShadow = exports.focusStyleBoxShadow = '0 3px 0 0';
var hoverStyles = function hoverStyles(_ref2) {
  var color = _ref2.color;
  return (0, _styledComponents.css)(["text-decoration:underline;color:", ";"], color);
};
var focusStyles = exports.focusStyles = (0, _styledComponents.css)(["box-shadow:", ";transition:box-shadow ", " ", ";&&{text-decoration:none;}"], focusStyleBoxShadow, _index.focusTransitionFade, _index.focusTransitionType);
var activeStyles = (0, _styledComponents.css)(["color:", ";"], (0, _index.cssColorValue)(_index.semanticColors.textBrightAccent));
var disabledStyles = (0, _styledComponents.css)(["color:", ";opacity:", ";cursor:not-allowed;"], (0, _index.cssColorValue)(_index.semanticColors.textSubdued), _index.opacityDisabled);
var standaloneHoverStyles = function standaloneHoverStyles(_ref3) {
  var semanticColor = _ref3.semanticColor,
    hasInheritColor = _ref3.hasInheritColor;
  return (0, _styledComponents.css)(["text-decoration:underline;color:", ";"], getTextColor({
    hasInheritColor: hasInheritColor,
    semanticColor: semanticColor || _index.semanticColors.textSubdued
  }));
};
var standaloneFocusStyles = function standaloneFocusStyles(_ref4) {
  var hasInheritColor = _ref4.hasInheritColor;
  return (0, _styledComponents.css)(["color:", ";"], getTextColor({
    hasInheritColor: hasInheritColor,
    semanticColor: _index.semanticColors.textBase
  }));
};
var standaloneActiveStyles = function standaloneActiveStyles(_ref5) {
  var semanticColor = _ref5.semanticColor,
    hasInheritColor = _ref5.hasInheritColor;
  return (0, _styledComponents.css)(["text-decoration:underline;color:", ";"], getTextColor({
    hasInheritColor: hasInheritColor,
    semanticColor: semanticColor || _index.semanticColors.textBase
  }));
};
var standaloneDisabledStyles = (0, _styledComponents.css)(["text-decoration:none;"]);
var Link = exports.Link = (0, _styledComponents["default"])( /*#__PURE__*/_react["default"].forwardRef(function Link(_ref6, ref) {
  var Component = _ref6.component,
    isUsingKeyboard = _ref6.isUsingKeyboard,
    useBrowserDefaultFocusStyle = _ref6.useBrowserDefaultFocusStyle,
    isHover = _ref6.isHover,
    isFocus = _ref6.isFocus,
    isActive = _ref6.isActive,
    standalone = _ref6.standalone,
    semanticColor = _ref6.semanticColor,
    hasInheritColor = _ref6.hasInheritColor,
    props = (0, _objectWithoutProperties2["default"])(_ref6, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({}, props, {
    ref: ref
  }));
})).withConfig({
  displayName: "Link",
  componentId: "sc-k8gsk-0"
})(["", ";", ";", " align-items:center;text-decoration:none;&[href],&:hover:not([disabled]){text-decoration:underline;}&[href]:hover{", ";}", " &[href]:active{", ";}&&{", ";", ";", ";}&[disabled],&[href][disabled],&[aria-disabled='true']{", ";}", ""], (0, _index.rootStyle)(), function (props) {
  return props.component === 'button' && (0, _styledComponents.css)(["", ";font-family:inherit;font-size:inherit;&:focus{", "}"], (0, _index.buttonLinkReset)(props.useBrowserDefaultFocusStyle), props.isUsingKeyboard && !props.useBrowserDefaultFocusStyle && focusStyles);
}, function (props) {
  return props.semanticColor ? (0, _styledComponents.css)(["color:", ";"], (0, _index.cssColorValue)(props.semanticColor)) : (0, _styledComponents.css)(["color:inherit;"]);
}, function (props) {
  return props.semanticColor ? hoverStyles({
    color: (0, _index.cssColorValue)(props.semanticColor)
  }) : hoverStyles({
    color: (0, _index.cssColorValue)(_index.semanticColors.textBrightAccent)
  });
}, function (props) {
  return !props.useBrowserDefaultFocusStyle && (0, _styledComponents.css)(["&[href]:focus{outline:none;", ";}"], props.isUsingKeyboard && focusStyles);
}, activeStyles, function (props) {
  return props.isHover && (props.semanticColor ? hoverStyles({
    color: (0, _index.cssColorValue)(props.semanticColor)
  }) : hoverStyles({
    color: (0, _index.cssColorValue)(_index.semanticColors.textBrightAccent)
  }));
}, function (props) {
  return props.isFocus && !props.useBrowserDefaultFocusStyle && focusStyles;
}, function (props) {
  return props.isActive && activeStyles;
}, disabledStyles, function (_ref7) {
  var standalone = _ref7.standalone,
    hasInheritColor = _ref7.hasInheritColor,
    semanticColor = _ref7.semanticColor,
    isUsingKeyboard = _ref7.isUsingKeyboard,
    isHover = _ref7.isHover,
    isFocus = _ref7.isFocus,
    isActive = _ref7.isActive;
  return standalone && (0, _styledComponents.css)(["color:", ";display:inline-flex;&,&[href]{text-decoration:none;}&[href]:focus{text-decoration:none;", ";}&[href]:active{", ";}&[href]:hover,&[href]:hover:focus{", ";}&&{", ";", ";", ";}&[disabled],&[href][disabled],&[aria-disabled='true']{", ";}"], getTextColor({
    hasInheritColor: hasInheritColor,
    semanticColor: semanticColor || _index.semanticColors.textSubdued
  }), isUsingKeyboard && standaloneFocusStyles({
    hasInheritColor: hasInheritColor
  }), standaloneActiveStyles({
    semanticColor: semanticColor,
    hasInheritColor: hasInheritColor
  }), standaloneHoverStyles({
    semanticColor: semanticColor,
    hasInheritColor: hasInheritColor
  }), isHover && standaloneHoverStyles({
    semanticColor: semanticColor,
    hasInheritColor: hasInheritColor
  }), isFocus && standaloneFocusStyles({
    hasInheritColor: hasInheritColor
  }), isActive && standaloneActiveStyles({
    semanticColor: semanticColor,
    hasInheritColor: hasInheritColor
  }), standaloneDisabledStyles);
});